// extracted by mini-css-extract-plugin
export default {"container":"About_container__+8uVD","body":"About_body__hsGv2","lineMask":"About_lineMask__zQpoc"};